// extracted by mini-css-extract-plugin
export default {"modalOverlay":"LoginModal_modalOverlay__pf+fA","modal":"LoginModal_modal__U8czT","closeBtn":"LoginModal_closeBtn__7Kv4i"};